import { useNavigate } from 'react-router-dom';
import { StepperCircle } from '../../../components/atoms/stepper-circle';
import Text from '../../atoms/typography/Text';
import { ColorEnum, FontSizeEnum, FontWeightEnum } from '../../enums';
import { Card } from '../../organisms/card';
import ButtonNew from '../button/Button';
import styles from './ScreeningOverviewIncompletedStep.module.css';
import { useTranslation } from 'react-i18next';
import HighlightBlock from '../highlightBlock/HighlightBlock';

interface ScreeningOverviewIncompleteStepProps {
    title: string;
    routePath: string;
    required?: boolean;
    alerts?: string[];
}

const ScreeningOverviewIncompleteStep = ({
    title,
    required = false,
    routePath,
    alerts,
}: ScreeningOverviewIncompleteStepProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Card className={styles.incompleteStepCard}>
            <div className={styles.headerContainer}>
                <div className={styles.circleAndTitle}>
                    <StepperCircle/>
                    <Text
                        className={styles.incompleteStepTitle}
                        color={ColorEnum.Gray800}
                        size={FontSizeEnum.Lg}
                        weight={FontWeightEnum.Regular}
                    >
                        {title}
                        {!required && (
                            <>
                                <span>&nbsp;</span>
                                <Text
                                    color={ColorEnum.Gray400}
                                    size={FontSizeEnum.Lg}
                                    weight={FontWeightEnum.Regular}
                                >({t('optional')})</Text>
                            </>
                        )}
                    </Text>
                </div>
                {alerts && alerts.length > 0 && (
                    <div className={styles.isMobile}>
                        {alerts.map((alert, index) => (
                            <HighlightBlock
                                key={index}
                                type='warning'
                            >
                                {t(`screening.overview.alert.${alert.replaceAll(' ', '_')}`)}
                            </HighlightBlock>
                        ))}
                    </div>
                )}
                <ButtonNew onClick={() => navigate(routePath)}>
                    {t('screening.overview.step.complete')}
                </ButtonNew>
            </div>
            {alerts && alerts.length > 0 && (
                <div className={styles.isDesktop}>
                    {alerts.map((alert, index) => (
                        <HighlightBlock
                            key={index}
                            type='warning'
                        >
                            {t(`screening.overview.alert.${alert.replaceAll(' ', '_')}`)}
                        </HighlightBlock>
                    ))}
                </div>
            )}
        </Card>
    );
}

export default ScreeningOverviewIncompleteStep;
